export type TermsSignatureFormState = {
  isTermsAccepted: boolean;
  printedName: string | null;
};

export const termsSignatureFormDefaultValues: TermsSignatureFormState = {
  isTermsAccepted: false,
  printedName: null,
};
